export const displayUserMenuSelector = ({displayUserMenu}) => displayUserMenu